"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributorCustomFilters = void 0;
const routes_1 = require("../../routes");
const getDistributorCustomFilters = (client) => async (distributorId) => {
    const url = routes_1.ENDPOINTS.GET_PARTNER_CUSTOM_CONFIG.applyParams(distributorId, 'filters');
    const { data } = await client.get(url);
    return data;
};
exports.getDistributorCustomFilters = getDistributorCustomFilters;
